<!-- <div class="page-wrapper-expanded-1200" -->
<div
  *ngIf="!isLoading"
  [ngClass]="{
    'page-wrapper-collapsed': sidebarCollapsed,
    'page-wrapper-expanded': !sidebarCollapsed
  }"
>
  <div class="header">
    <header class="home-header"></header>
  </div>

  <div class="summary">
    <summary-card></summary-card>
  </div>
  <div class="tools">
    <tools-card></tools-card>
  </div>
  <div class="glance">
    <at-a-glance [notifications]="notifications"></at-a-glance>
  </div>
</div>
